<template>
  <div v-if="searched_users.length > 0">
    <div class="position-absolute col-md-5" style="padding-left: unset;">
        <ul class="list-group rounded-0 border border-1 border-dark shadow-lg">
            <li v-for="(user, index) in searched_users" :key="index" class="list-group-item btn-link" style="cursor: pointer;" @click="addAttendee(user)">
              <span class="text-primary">{{ user.first_name }} {{ user.last_name }}</span>
              <br />
              <small class="text-muted"> <i class="fa fa-envelope small"></i> {{ user.email }}</small>
            </li>
        </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    searched_users: {
      type: Array,
      default: null,
    },
    searchUserQuery: {
      type: String,
      default: null,
    },
    occurrence: {
      type: [String, Number],
      default: null,
    },
    meeting_id: {
      type: [String, Number],
      default: null,
    },
    network_id: {
      type: [String, Number],
      default: null,
    },
  },
  methods: {
    addAttendee(user){
      this.$swal.fire({
        icon: 'info',
        title: 'Do you really want to add this user as an attendee?',
        showCancelButton: true,
          confirmButtonText : this.$t('ResearchCreds.yes'),
          customClass: {
            confirmButton: 'btn btn-success mx-1',
            cancelButton: 'btn btn-primary mx-1',
          },
          buttonsStyling: false,
      }).then( (result) => {
        if(result.isConfirmed){
          let form = new FormData();
          form.append('user_id', user.user_id);
          form.append('meeting_id', this.meeting_id);
          form.append('network_meeting_id', this.$route.params.id);
          form.append('occurrence_id', this.occurrence ? this.occurrence : '');
          form.append('network_id', this.network_id);
          this.$http.post('meetings/add-attendee', form).then(() => {
            this.$swal.fire({
              icon: 'success',
              title: this.$t('success'),
            }).then(() => {
              this.$emit('reload-meeting-list');
            });
          });
        }
      });
    },
  },
};
</script>